<template>
  <div>
    <div class="row pr-4 pl-4 mb-n3">
      <div
        id="book-errors"
        class="col-12"
      >
        <Errors :errors="errors" />
        <Errors :errors="bookErrors" />
      </div>
    </div>
    <!-- DATE + PAX -->
    <div
      v-if="askFor === 'DateAndPax'"
      class="row p-4 icon-inputs"
    >
      <div class="col-12 col-md-6 mb-2 mb-lg-0">
        <h6>{{ $t('lang.transfer.date') }}</h6>
        <div class="form-group">
          <Datetime
            v-model="datetime"
            input-id="start_date"
            input-class="form-control"
            type="datetime"
            style="height: 50px; width: 100%"
            :value="now"
            :hour-step="1"
            :minute-step="5"
            :min-datetime="now"
            :week-start="7"
            :format="{
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit'
            }"
            :phrases="{
              ok: $t('lang.search.calendar_continue'),
              cancel: $t('lang.search.calendar_cancel'),
            }"
            :placeholder="$t('lang.transfer.date')"
            auto
          />
          <i class="icon-calendar" />
        </div>
      </div>
      <div class="col-12 col-md-6 mb-2 mb-lg-0">
        <h6>{{ $t('lang.transfer.passengers') }}</h6>
        <div class="form-group">
          <input
            id="pax"
            v-model="pax"
            class="form-control"
            type="number"
            min="1"
            max="25"
            style="padding-right: 40px;"
            pattern="\d*"
          >
          <span class="btn-inside-input">
            <button
              type="button"
              @click="paxNumber('minus')"
            >
              <span class="icon-minus" />

            </button>
            <button
              type="button"
              @click="paxNumber('plus')"
            >
              <span class="icon-plus" />
            </button>
          </span>

          <i class="icon-user" />
        </div>
      </div>
      <div class="col-12 text-center text-lg-right">
        <button
          class="btn btn-main-color mt-lg-2 pl-4 pr-4 book-btn"
          name="btn_submit"
          @click="sendDateAndPax()"
        >
          {{ $t('lang.transfer.next') }}
        </button>
        <p class="mt-2 mb-0 small color-gray">
          {{ $t('lang.transfer.cancellation', {hs: selectedCar.cancellation}) }}
        </p>
      </div>
    </div>

    <!-- EXTRA BOOKING DATA -->
    <form
      v-if="askFor === 'CheckoutData'"
      class="row p-4 icon-inputs"
      @submit.prevent="sendCheckoutData()"
    >
      <div class="col-12 col-md-6 mb-2 mb-lg-0 phone-with-country-code">
        <h6>{{ $t('lang.transfer.phone') }} <small class="color_text">*</small></h6>
        <div class="form-group">
          <VueTelInput
            :default-country="user.country"
            :dropdown-options="{
              'showDialCodeInList':true,
              'showDialCodeInSelection':false,
              'showFlags':true,
              'showSearchBox':true,
            }"
            :input-options="{
              'autofocus':true,
              'showDialCode':true,
              'placeholder':'+54 9 11 3288 4589',
              'required':true,
            }"
            :mode="'international'"
            :valid-characters-only="true"
            @validate="validatePhoneNumber"
          />
          <i
            :class="userPhoneIcon"
            aria-hidden="true"
          />
        </div>
      </div>
      <div
        v-for="field in fieldsToShow"
        :key="field.id"
        class="col-12 col-md-6 mb-2 mb-lg-0"
      >
        <h6>{{ field.label }} <small class="color_text">*</small></h6>
        <div
          v-if="field.type === 'text'"
          class="form-group"
        >
          <input
            :id="field.id"
            v-model="checkoutData[field.id]"
            :aria-label="field.label"
            class="form-control"
            type="text"
            required
          >
        </div>
        <div v-if="field.type === 'boolean'">
          <div class="custom-control custom-switch">
            <input
              :id="field.id"
              v-model="checkoutData[field.id]"
              type="checkbox"
              class="custom-control-input"
            >
            <label
              :for="field.id"
              class="custom-control-label"
            >
              <span v-if="checkoutData[field.id]">{{ $t('lang.transfer.yes') }}</span>
              <span v-else>{{ $t('lang.transfer.no') }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-lg-right">
        <button
          class="btn btn-main-color mt-lg-2 pl-4 pr-4 book-btn"
          name="btn_submit"
          type="submit"
        >
          {{ $t('lang.transfer.next') }}
        </button>
        <p
          v-if="selectedCar.cancellation"
          class="mt-2 mb-0 small color-gray"
        >
          {{ $t('lang.transfer.cancellation', {hs: selectedCar.cancellation}) }}
        </p>
      </div>
    </form>
    <p class="text-right float-right color-gray mt-1">
      {{ $t('lang.transfer.required') }}
    </p>
  </div>
</template>

<script>
import { Datetime } from 'vue-datetime';
import { VueTelInput } from 'vue-tel-input';
// You need a specific loader for CSS files
import '../../assets/css/vue-datetime.min.css';
import 'vue-tel-input/dist/vue-tel-input.css';
import Errors from '@/components/Alerts/Errors';

export default {
  name: 'TransferBookingData',
  components: {
    Errors,
    Datetime,
    VueTelInput,
  },
  props: {
    askFor: {
      type: String,
      required: true,
    },
    requiredData: {
      type: Array,
      default: null,
    },
    errors: {
      type: Object,
      default: {},
    },
    selectedCar: {
      type: Object,
      default: {},
    },
    user: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      pax: 1,
      datetime: null,

      now: new Date(
        ((new Date()).setMinutes((new Date()).getMinutes())),
      ).toISOString(), // Now in the correct timezone

      userPhoneIcon: null,
      checkoutData: [],
      bookErrors: {},
      userPhone: {
        telephone_cc: '',
        telephone: '',
      },
      fieldsToShow: null,
    };
  },

  watch: {
    requiredData() {
      if (this.requiredData != null) {
        this.fieldsToShow = this.requiredData.filter((field) => field.show === true);
        this.checkoutData = {};
        // set checkoutData values to show and update values on inputs
        this.requiredData.forEach((field) => {
          this.checkoutData[field.id] = field.value;
        });
      }
    },
  },
  created() {
    this.pax = this.selectedCar.places;
  },

  mounted() {
    this.$scrollTo('#booking-data');
  },

  methods: {
    paxNumber(action) {
      if (action === 'minus') {
        if (this.pax > 1) {
          this.pax--;
        }
      } else if (this.pax < this.selectedCar.places) {
        this.pax++;
      }
    },

    sendDateAndPax() {
      if (!this.datetime) {
        this.bookErrors = { data_error: [this.$t('lang.transfer.pick_date')] };
        return false;
      }
      this.bookErrors = {};
      let date = new Date(this.datetime);
      date = `${date.getFullYear()}-${
        (`00${date.getMonth() + 1}`).slice(-2)}-${
        (`00${date.getDate()}`).slice(-2)} ${
        (`00${date.getHours()}`).slice(-2)}:${
        (`00${date.getMinutes()}`).slice(-2)}:${
        (`00${date.getSeconds()}`).slice(-2)}`;

      this.$emit('updatedDateAndPax', date, this.pax);

      return true;
    },

    sendCheckoutData() {
      if (!this.userPhone.telephone) {
        this.bookErrors = { data_error: [this.$t('lang.transfer.phone_error')] };
        this.$scrollTo('#book-errors');
        return false;
      }
      const payload = {};

      if (this.requiredData != null) {
        // format the checkoutData list as requested by backend
        payload.additional_data = Object.keys(this.checkoutData).map((key) => ({
          id: key,
          value: this.checkoutData[key],
        }));
      }

      payload.user = this.userPhone;
      this.$emit('updatedCheckoutData', payload);
      return true;
    },

    validatePhoneNumber(phoneObject) {
      if (phoneObject.valid) {
        this.userPhone.telephone = phoneObject.nationalNumber;
        this.userPhone.telephone_cc = phoneObject.countryCallingCode;
        this.userPhoneIcon = 'icon-check-1 text-success';
        this.bookErrors = {};
      } else {
        this.userPhone.telephone = null;
        this.userPhone.telephone_cc = null;
        this.userPhoneIcon = 'icon-cancel-1 text-danger';
      }
    },
  },
};
</script>

<style scoped>

</style>
